module.exports = __webpack_public_path__ + "img/vector-shape3.e9c80b27.png";